import { ActionTypes } from '../constants/index';

export function getPages(): Object {
  return {
    type: ActionTypes.PAGE_GET_REQUEST,
    payload: {},
  };
}

export function refreshPages(): Object {
  return {
    type: ActionTypes.PAGE_REFRESH_REQUEST,
    payload: {},
  };
}


export function addPage(): Object {
  return {
    type: ActionTypes.PAGE_ADD_REQUEST,
    payload: {},
  };
}

export function addTutorialPage(): Object {
  return {
    type: ActionTypes.PAGE_TUTORIAL_ADD_REQUEST,
    payload: {},
  };
}

export function deletePage(pageUrlsafe: string): Object {
  return {
    type: ActionTypes.PAGE_DELETE_REQUEST,
    payload: { pageUrlsafe },
  };
}

export function addPageVariant(pageUrlsafe: string): Object {
  return {
    type: ActionTypes.PAGE_VARIANT_ADD_REQUEST,
    payload: { pageUrlsafe },
  };
}

export function updatePageAttr(
  pageUrlsafe: string,
  changes: Object,
): Object {
  return {
    type: ActionTypes.PAGE_UPDATE_REQUEST,
    payload: { pageUrlsafe, changes },
  };
}

export function checkPageSubdomainAvailability(
  pageUrlsafe: string,
  subdomain: string,
): Object {
  return {
    type: ActionTypes.PAGE_CHECK_SUBDOMAIN_REQUEST,
    payload: { pageUrlsafe, subdomain },
  };
}

export function deletePageVariant(pageUrlsafe: string, variantUrlsafe: string): Object {
  return {
    type: ActionTypes.PAGE_VARIANT_DELETE_REQUEST,
    payload: { pageUrlsafe, variantUrlsafe },
  };
}

export function clonePageVariant(pageUrlsafe: string, variantUrlsafe: string): Object {
  return {
    type: ActionTypes.PAGE_VARIANT_CLONE_REQUEST,
    payload: { pageUrlsafe, variantUrlsafe },
  };
}

export function updatePageVariantAttr(
  pageUrlsafe: string,
  variantUrlsafe: string,
  changes: Object
): Object {
  return {
    type: ActionTypes.PAGE_VARIANT_UPDATE_REQUEST,
    payload: { pageUrlsafe, variantUrlsafe, changes },
  };
}

export function updatePageVariantDistribution(
  pageUrlsafe: string,
  variantUrlsafe: string,
  value: number
): Object {
  return {
    type: ActionTypes.PAGE_UDPATE_DISTRIBUTION_LOCAL,
    payload: { pageUrlsafe, variantUrlsafe, value },
  };
}

export function updatePageVariantTutorialUpdateLocal(
  pageUrlsafe: string,
  variantUrlsafe: string,
  value: bool
): Object {
  return {
    type: ActionTypes.PAGE_VARIANT_TUTORIAL_UPDATE_LOCAL,
    payload: { pageUrlsafe, variantUrlsafe, value },
  };
}



// WEBPACK FOOTER //
// ./scripts/actions/page.js